import useShopAttrs from './useShopAttrs';
import { planGetLimit } from '@next-is-free-monorepo/next-is-free-shared-utils';
import { PlanLimit } from '@next-is-free-monorepo/next-is-free-types';

function usePlanLimits() {
  const shopAttrs = useShopAttrs();

  function usedPlanLimits(current: number, limit: PlanLimit){
    const denominator = planGetLimit(shopAttrs.data.subscription_plan, limit)
    return `${current}/${denominator === Infinity ? '∞' : denominator}`
  }

  return { usedPlanLimits };
}

export default usePlanLimits;
